import { lazy } from "react";
import Loadable from "app/components/Loadable";

const LoanMasterView = Loadable(lazy(() => import("./LoanMasterView")));

const loanmasterviewRoute = [{ path: "/loanmaster-view", element: <LoanMasterView /> }];
export default loanmasterviewRoute;
